import { Image, Svg, Text, View } from "@react-pdf/renderer";
import React from "react";
import { styles } from "./styles";
import {
  BankCheckIcon,
  BankIcon,
  LoginScreen,
  OnlinePaymentLinkIcon,
  QRCodeIcon,
} from "../../../../assets/images";

type AppProps = {
  downloadRevenuesData: any;
};

let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
let blobToken = process.env.REACT_APP_BLOB_TOEKN;

const BatchSummaryPaymentDetails = ({ downloadRevenuesData }: AppProps) => {
  const checkBankDetailsObjectKeyValue =
    downloadRevenuesData?.primary_details?.payment_details?.bank_details &&
    Object.values(
      downloadRevenuesData?.primary_details?.payment_details?.bank_details
    ).some((value) => value !== "" && value !== null && value !== undefined);

  return (
    <View style={styles.sub_header_1} break>
      {/* left  */}
      <View style={{ maxWidth: "40%" }}>
        {!!downloadRevenuesData?.primary_details?.payment_details?.length ? (
          <Text
            style={{
              ...styles.sub_header_small,
              textAlign: "left",
              paddingTop: "5px",
            }}
          >
            Direct Credit
          </Text>
        ) : null}
        {!!downloadRevenuesData?.primary_details?.payment_details?.length ? (
          <Text
            style={{
              ...styles.text,
              textAlign: "left",
              fontSize: "8px",
              paddingTop: "5px",
            }}
          >
            Please make payment into the following account:
          </Text>
        ) : null}
        {downloadRevenuesData?.primary_details?.payment_details?.cheque_details
          ?.cheque_payable_to ? (
          <View
            style={{
              flexDirection: "row",
              alignContent: "center",
            }}
          >
            <View style={{ marginRight: "7px", marginTop: "2px" }}>
              <Image
                style={{ width: "16px", height: "16px" }}
                src={BankCheckIcon}
              />
            </View>
            <View>
              {downloadRevenuesData?.primary_details?.payment_details
                ?.cheque_details?.cheque_payable_to ? (
                <View style={styles.flexCenter}>
                  <Text
                    style={{
                      ...styles.sub_header_small,
                      fontSize: "8px",
                      textAlign: "left",
                      paddingTop: "5px",
                    }}
                  >
                    Cheque Payable to:{" "}
                  </Text>
                  <Text
                    style={{
                      ...styles.text,
                      textAlign: "left",
                      paddingTop: "5px",
                    }}
                  >
                    {" " +
                      downloadRevenuesData?.primary_details?.payment_details
                        ?.cheque_details?.cheque_payable_to}
                  </Text>
                </View>
              ) : null}
            </View>
          </View>
        ) : null}
        {checkBankDetailsObjectKeyValue ? (
          <View
            style={{
              flexDirection: "row",
              alignContent: "center",
              marginTop: "1px",
            }}
          >
            <View style={{
              marginRight: "7px",
              // marginTop: "5px"
            }}>
              <Image style={{ width: "16px", height: "16px" }} src={BankIcon} />
            </View>
            <View>
              {downloadRevenuesData?.primary_details?.payment_details
                ?.bank_details?.account_no ? (
                <View style={styles.flexCenter}>
                  <Text
                    style={{
                      ...styles.sub_header_small,
                      fontSize: "8px",
                      textAlign: "left"
                    }}
                  >
                    Account No. :{" "}
                  </Text>
                  <Text
                    style={{
                      ...styles.text,
                      textAlign: "left",
                    }}
                  >
                    {
                      downloadRevenuesData?.primary_details?.payment_details
                        ?.bank_details?.account_no
                    }
                  </Text>
                </View>
              ) : null}
              {downloadRevenuesData?.primary_details?.payment_details
                ?.bank_details?.bank_name ? (
                <View style={styles.flexCenter}>
                  <Text
                    style={{
                      ...styles.sub_header_small,
                      fontSize: "8px",
                      textAlign: "left",
                      // paddingTop: "5px",
                    }}
                  >
                    {" "}
                    Bank Name :{" "}
                  </Text>
                  <Text
                    style={{
                      ...styles.text,
                      textAlign: "left",
                      // paddingTop: "5px",
                    }}
                  >
                    {
                      downloadRevenuesData?.primary_details?.payment_details
                        ?.bank_details?.bank_name
                    }
                  </Text>
                </View>
              ) : null}
              {downloadRevenuesData?.primary_details?.payment_details
                ?.bank_details?.beneficiary_name ? (
                <View style={styles.flexCenter}>
                  <Text
                    style={{
                      ...styles.sub_header_small,
                      fontSize: "8px",
                      textAlign: "left",
                      // paddingTop: "5px",
                    }}
                  >
                    {" "}
                    Beneficiary Name :{" "}
                  </Text>
                  <Text
                    style={{
                      ...styles.text,
                      textAlign: "left",
                      // paddingTop: "5px",
                    }}
                  >
                    {
                      downloadRevenuesData?.primary_details?.payment_details
                        ?.bank_details?.beneficiary_name
                    }
                  </Text>
                </View>
              ) : null}
              {downloadRevenuesData?.primary_details?.payment_details
                ?.bank_details?.ifsc_code ? (
                <View style={styles.flexCenter}>
                  <Text
                    style={{
                      ...styles.sub_header_small,
                      fontSize: "8px",
                      textAlign: "left",
                      // paddingTop: "5px",
                    }}
                  >
                    {" "}
                    IFSC Code :{" "}
                  </Text>
                  <Text
                    style={{
                      ...styles.text,
                      textAlign: "left"
                    }}
                  >
                    {
                      downloadRevenuesData?.primary_details?.payment_details
                        ?.bank_details?.ifsc_code
                    }
                  </Text>
                </View>
              ) : null}
              {downloadRevenuesData?.primary_details?.payment_details
                ?.bank_details?.swift_code ? (
                <View style={styles.flexCenter}>
                  <Text
                    style={{
                      ...styles.sub_header_small,
                      fontSize: "8px",
                      textAlign: "left",
                      // paddingTop: "5px",
                    }}
                  >
                    {" "}
                    Swift Code :{" "}
                  </Text>
                  <Text
                    style={{
                      ...styles.text,
                      textAlign: "left",
                      // paddingTop: "5px",
                    }}
                  >
                    {
                      downloadRevenuesData?.primary_details?.payment_details
                        ?.bank_details?.swift_code
                    }
                  </Text>
                </View>
              ) : null}
              {downloadRevenuesData?.primary_details?.payment_details
                ?.bank_details?.bank_branch_address ? (
                <View style={styles.flexCenter}>
                  <Text
                    style={{
                      ...styles.sub_header_small,
                      fontSize: "8px",
                      textAlign: "left",
                      // paddingTop: "5px",
                    }}
                  >
                    {" "}
                    Bank Branch Address :{" "}
                  </Text>
                  <Text
                    style={{
                      ...styles.text,
                      textAlign: "left",
                      // paddingTop: "5px",
                    }}
                  >
                    {
                      downloadRevenuesData?.primary_details?.payment_details
                        ?.bank_details?.bank_branch_address
                    }
                  </Text>
                </View>
              ) : null}
              {downloadRevenuesData?.primary_details?.payment_details
                ?.bank_details?.city ? (
                <View style={styles.flexCenter}>
                  <Text
                    style={{
                      ...styles.sub_header_small,
                      fontSize: "8px",
                      textAlign: "left",
                      // paddingTop: "5px",
                    }}
                  >
                    {" "}
                    City :{" "}
                  </Text>
                  <Text
                    style={{
                      ...styles.text,
                      textAlign: "left",
                      // paddingTop: "5px",
                    }}
                  >
                    {
                      downloadRevenuesData?.primary_details?.payment_details
                        ?.bank_details?.city
                    }
                  </Text>
                </View>
              ) : null}
            </View>
          </View>
        ) : null}
        {downloadRevenuesData?.primary_details?.payment_details
          ?.online_payment_details?.online_payment_link ? (
          <View
            style={{
              flexDirection: "row",
              alignContent: "center",
              // marginTop: "10px",
            }}
          >
            <View style={{
              marginRight: "7px",
              //  marginTop: "5px"
            }}>
              <Image
                style={{ width: "16px", height: "16px" }}
                src={OnlinePaymentLinkIcon}
              />
            </View>
            <View>
              {downloadRevenuesData?.primary_details?.payment_details
                ?.online_payment_details?.online_payment_link ? (
                <View style={styles.flexCenter}>
                  <Text
                    style={{
                      ...styles.sub_header_small,
                      fontSize: "8px",
                      textAlign: "left",
                      // paddingTop: "5px",
                    }}
                  >
                    {" "}
                    Online Payment Link :{" "}
                  </Text>
                  <Text
                    style={{
                      ...styles.text,
                      textAlign: "left",
                      // paddingTop: "5px",
                    }}
                  >
                    {
                      downloadRevenuesData?.primary_details?.payment_details
                        ?.online_payment_details?.online_payment_link
                    }
                  </Text>
                </View>
              ) : null}
            </View>
          </View>
        ) : null}
        {downloadRevenuesData?.primary_details?.payment_details?.upi_details ? (
          <View
            style={{
              flexDirection: "row",
              alignContent: "center",
              // marginTop: "10px",
            }}
          >
            {downloadRevenuesData?.primary_details?.payment_details?.upi_details
              ?.upi_id ||
              downloadRevenuesData?.primary_details?.payment_details?.upi_details
                ?.upi_image?.file_url ? (
              <View style={{ marginRight: "7px", marginTop: "2px" }}>
                <Image
                  style={{ width: "16px", height: "16px" }}
                  src={QRCodeIcon}
                />
              </View>
            ) : null}
            <View>
              {downloadRevenuesData?.primary_details?.payment_details
                ?.upi_details ? (
                <View style={styles.flexColumn}>
                  {downloadRevenuesData?.primary_details?.payment_details
                    ?.upi_details?.upi_id ? (
                    <View style={styles.flexColumn}>
                      <Text
                        style={{
                          ...styles.sub_header_small,
                          fontSize: "8px",
                          textAlign: "left",
                          // paddingTop: "5px",
                        }}
                      >
                        {" "}
                        Pay By UPI ID:{" "}
                      </Text>
                      <Text
                        style={{
                          ...styles.text,
                          textAlign: "left",
                          // paddingTop: "5px",
                        }}
                      >
                        {
                          downloadRevenuesData?.primary_details?.payment_details
                            ?.upi_details?.upi_id
                        }
                      </Text>
                    </View>
                  ) : null}
                  {downloadRevenuesData?.primary_details?.payment_details
                    ?.upi_details?.upi_image?.file_url ? (
                    <View style={styles.flexColumn}>
                      <Text
                        style={{
                          ...styles.sub_header_small,
                          fontSize: "8px",
                          textAlign: "left",
                          // paddingTop: "5px",
                        }}
                      >
                        {" "}
                        Pay By QR Code :{" "}
                      </Text>
                      <Image
                        style={styles.qrCode}
                        src={`${blobBaseUrl}${downloadRevenuesData?.primary_details?.payment_details?.upi_details?.upi_image?.file_url}?${blobToken}`}
                      />
                    </View>
                  ) : null}
                </View>
              ) : null}
            </View>
          </View>
        ) : null}
      </View>

      {/* right  */}
      <View style={{ maxWidth: "50%" }}>
        {downloadRevenuesData?.primary_details?.business_address_details?.notes
          ?.length ? (
          <Text
            style={{
              ...styles.sub_header_small,
              paddingTop: "5px",
              paddingBottom: "4px",
            }}
          >
            Declaration
          </Text>
        ) : null}
        <Text style={{ ...styles.text }}>
          {
            downloadRevenuesData?.primary_details?.business_address_details
              ?.notes
          }
        </Text>
      </View>
    </View>
  );
};

export default BatchSummaryPaymentDetails;
